import { getAxiosInstance } from "../../../../api";

export const PrintCertficate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/printing-report/create`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const PreviewCertficate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/printing-report/preview`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const uploadKalyanCertificate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/kalyan-certificates`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
